<template>
    <div class="pmCustomSearchContent">
        <el-form :model="form" ref="formRef" :label-width="labelWidth" :label-suffix="labelSuffix">
            <el-row :gutter="gutter">
                <template v-for="(item, index) in options">
                    <el-col v-if="isShow(item, index)"
                            :key="item.key"
                            :span="item.span || span">
                        <el-form-item
                                :prop="item.key"
                                :size="size"
                                :label="(item.label || '') + '：'"
                                :label-width="item.labelWidth">
                            <template v-if="item.slot">
                                <slot :name="item.slot" v-bind:form="form"></slot>
                            </template>
                            <template v-else>
                                <el-input  v-if="item.type === 'input'"
                                           v-model="form[item.key]"
                                           :size="size"
                                           :disabled="item.disabled"
                                           :placeholder="item.placeholder"
                                           :clearable="item.clearable"></el-input>
                                <el-select v-else-if="item.type === 'select'"
                                           v-model="form[item.key]"
                                           :size="size"
                                           :placeholder="item.placeholder"
                                           :filterable="item.filterable"
                                           :clearable="item.clearable"
                                           @change="item.change && item.change(form[item.key])">
                                    <el-option v-for="(option, idx) in item.options" :key="idx" :label="option.label" :value="option.value"></el-option>
                                </el-select>
                                <el-date-picker v-else-if="item.type === 'date'"
                                                v-model="form[item.key]"
                                                :size="size"
                                                :type="item.model || 'date'"
                                                :placeholder="item.placeholder"
                                                format="yyyy-MM-dd"
                                                value-format="yyyy-MM-dd"
                                                range-separator="至"
                                                start-placeholder="开始日期"
                                                end-placeholder="结束日期"
                                                @change="item.change && item.change(form[item.key])"
                                                style="width:100%;"
                                                :clearable="item.clearable"></el-date-picker>
                                <el-radio-group v-else-if="item.type === 'radio'"
                                                v-model="form[item.key]"
                                                :size="size"
                                                :placeholder="item.placeholder">
                                    <el-radio v-for="(option, idx) in item.options" :key="idx" :label="option.value">{{option.label}}</el-radio>
                                </el-radio-group>
                                <el-checkbox-group v-else-if="item.type === 'checkbox'"
                                                   v-model="form[item.key]"
                                                   :placeholder="item.placeholder">
                                    <el-checkbox v-for="(option, idx) in item.options" :key="idx" :label="option.value">{{option.label}}</el-checkbox>
                                </el-checkbox-group>
                                <el-switch
                                        v-else-if="item.type === 'switch'"
                                        v-model="form[item.key]"
                                ></el-switch>
                            </template>
                        </el-form-item>
                    </el-col>
                </template>
                <el-col :span="span" :class="(options.length == 1?'leftPo':'rightPo')" style="padding-bottom: 16px;">
                    <el-button size="mini" type="text" v-if="showMoreBtn && !moreSearchItem" @click="moreSearchItem = true"
                               icon="el-icon-arrow-down">展开</el-button>
                    <el-button size="mini" type="text" v-if="showMoreBtn && moreSearchItem" @click="moreSearchItem = false"
                               icon="el-icon-arrow-up">收起</el-button>
                    <el-button size="small" type="primary" @click="searchBtn">搜索</el-button>
                    <el-button plain size="small" type="primary" @click="refresh">重置</el-button>
                    <slot name="afterSearchButtonSlot"></slot>
                </el-col>
                <slot name="afterSearchComSlot"></slot>
            </el-row>

        </el-form>
    </div>
</template>

<script>
    export default {
        props: {
            // options, form表单的配置项label,type,placeholder,disabled,clearable,filterable,change
            options: {
                type: Array,
                default: () => {
                    return []
                }
            },
            form: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            // 每行显示几个
            col: {
                type: Number,
                default: 4
            },
            gutter: {
                type: Number,
                default: 16
            },
            labelWidth: {
                type: String,
                default: '84px'
            },
            labelSuffix: {
                type: String,
                default: ''
            },
            size: {
                type: String,
                default: 'small'
            },

        },
        computed: {
            // 根据col计算每个el-col的span
            span() {
                return 24 / this.col
            },
            showMoreBtn() {
                return this.options.length >= this.col
            },
        },
        data() {
            return {
                moreSearchItem: false,
                formList: [],
            }
        },
        methods: {
            isShow(item, index) {
                return this.moreSearchItem || index < (this.col-1)
            },
            searchBtn() {
                this.$emit('search', this.form);
            },
            refresh() {
                this.$refs.formRef.resetFields();
                this.$emit('reset');
                this.searchBtn()
            },
            setSearchConfigsData(props,key,value){
                let keyIdx = this.options.findIndex(item => item.key == props);
                if(keyIdx > -1){
                    this.options[keyIdx][key] = value;
                }
            },
        },
        mounted() {
            this.searchBtn()
        },
    }
</script>
<style>
    .pmCustomSearchContent .el-form-item.el-form-item--small .el-form-item__content{
        line-height: 32px!important;
    }
    .pmCustomSearchContent .el-form-item.el-form-item--small .el-form-item__label{
        line-height: 32px!important;
    }
</style>
<style scoped>
    .leftPo{
        float: left;
        text-align: left;
    }
    .rightPo{
        float: right;
        text-align: right;
    }
    .pmCustomSearchContent{
        background-color: #FFF;
        padding: 16px 16px 0px;
        margin-bottom: 16px;
    }
    .pmCustomSearchContent .el-form-item{
        margin-bottom: 16px;
    }

</style>